import BackgroundImage from "@assets/home-page-background-new.jpg";
import BackgroundImageMob from "@assets/home-page-background_mob.jpg";
import styled from "styled-components";
import { isHandHeldDevice } from "../utils/deviceUtils";

export const LandingDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const OuterMiddleFooterContainer = styled.div`
  background-image: ${isHandHeldDevice()
    ? `url(${BackgroundImageMob})`
    : `url(${BackgroundImage})`};
  width: 100%;
  height: max-content;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
`;

export const InnerMiddleFooterContainer = styled.div`
  height: max-content;
  width: 100%;
  scrollbar-width: thin;
  margin-bottom: 0px;
  position: relative;
  min-height: calc(100vh - 66px);
  background-color: rgba(0, 0, 0, 0.2);
`;
